import { render, staticRenderFns } from "./BillingLayout.vue?vue&type=template&id=042470d6"
import script from "./BillingLayout.vue?vue&type=script&lang=js"
export * from "./BillingLayout.vue?vue&type=script&lang=js"
import style0 from "./BillingLayout.vue?vue&type=style&index=0&id=042470d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports